import React from 'react'
import { Route } from 'react-router-dom'
import VerifyPhone from './VerifyPhone';

import { verifyPhone } from "../../../constants/routePaths"

const VerifyPhoneRoute = [
  <Route
    key="VerifyPhone"
    exact path={verifyPhone}
    component={VerifyPhone}
  />,
];

export default VerifyPhoneRoute